import router from "../router";
import PageLoader from "../components/PageLoader";
import store from "../store";

export default {
  data() {
    return {
      activeLoader: false
    };
  },
  watch: {
    pageLoader: function(value) {
      if (value && !this.activeLoader) {
        this.activeLoader = true;
        this.showPageLoader();
      } else {
        this.activeLoader = false;
        this.hidePageLoader();
      }
    }
  },

  computed: {
    pageLoader() {
      return store.state.showPageLoader;
    },
    hashData() {
      if (typeof this.$route.hash != "undefined") {
        let hashArr = this.$route.hash.split("&");
        let hashObj = {};
        let hashSpliced = hashArr.slice(1);

        for (let index = 0; index < hashSpliced.length; index++) {
          const element = hashSpliced[index];
          let [key, value] = element.split("=");

          if (!this.$moment(value).isValid() && key == "date") {
            value = this.$moment(new Date()).format("YYYY-MM-DD");
          }
          hashObj[key] = value;
        }
        if (
          !this.$route.path.includes("app-") &&
          !this.$route.path.includes("surg-") &&
          !this.$route.path.includes("time-update")
        ) {
          localStorage.setItem("hashData", JSON.stringify(hashObj));
        }
        return hashObj;
      }
      return "";
    }
  },
  methods: {
    goBack: function() {
      router.go(-1);
    },
    goHome: function() {
      router.push("/dashboard");
    },
    showPageLoader: function() {
      this.$modal.show("pageLoader");
    },
    hidePageLoader: function() {
      this.$modal.hide("pageLoader");
    }
  }
};
